<template>
    <q-page padding class="imagenes-page">
        <!-- Header moderno mejorado -->
        <div class="page-header">
            <div class="row items-center no-wrap">
                <q-avatar size="56px" color="primary" text-color="white">
                    <q-icon name="collections" size="32px" />
                </q-avatar>
                <div class="col q-ml-md">
                    <div class="text-h4 text-weight-bold text-grey-9">Gestión de Imágenes de Productos</div>
                    <div class="text-subtitle2 text-grey-6">
                        Administre y asigne imágenes a los productos del catálogo
                    </div>
                </div>
                <q-chip
                    v-if="itemSelected.length > 0"
                    color="primary"
                    text-color="white"
                    icon="check_circle"
                    class="chip-active"
                >
                    {{ itemSelected.length }} {{ itemSelected.length === 1 ? 'producto seleccionado' : 'productos seleccionados' }}
                </q-chip>
            </div>
        </div>

        <div class="row q-col-gutter-lg q-mt-md">
            <div class="col-12 col-md-6">
                <q-card class="productos-card">
                    <q-card-section class="card-header">
                        <div class="row items-center no-wrap">
                            <q-icon name="inventory_2" size="28px" class="q-mr-sm" />
                            <div class="col">
                                <div class="text-h6 text-weight-bold">Catálogo de Productos</div>
                                <div class="text-caption text-white-7 q-mt-xs">
                                    {{ items.length }} {{ items.length === 1 ? 'producto disponible' : 'productos disponibles' }}
                                </div>
                            </div>
                        </div>
                    </q-card-section>

                    <q-separator />

                    <q-card-section class="q-pa-md">
                        <GltnInput
                            v-model="itemSearch"
                            label="Buscar producto"
                            placeholder="Buscar por código, descripción o grupo..."
                            debounce="1000"
                            @update:modelValue="productoSearch($event)"
                            :loading="loading"
                            outlined
                            dense
                            clearable
                        >
                            <template v-slot:prepend>
                                <q-icon name="search" color="primary" />
                            </template>
                        </GltnInput>
                    </q-card-section>

                    <q-separator />

                    <q-card-section class="q-pa-none">
                        <q-scroll-area style="height: 500px">
                            <q-list v-if="items.length > 0" separator>
                                <template
                                    v-for="item in items"
                                    :key="item.B1_COD"
                                >
                                    <q-item
                                        tag="label"
                                        v-ripple
                                        clickable
                                        class="product-item"
                                    >
                                        <q-item-section side top>
                                            <q-checkbox
                                                v-model="itemSelected"
                                                :val="item"
                                                color="primary"
                                            />
                                        </q-item-section>
                                        <q-item-section avatar>
                                            <q-avatar size="56px" rounded>
                                                <q-img
                                                    alt="Imagen del producto"
                                                    fit="contain"
                                                    :src="`${productosImagesPath}/${item.B1_COD}.webp`"
                                                    :error-src="noImagePath"
                                                />
                                            </q-avatar>
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label class="text-weight-bold text-grey-9">
                                                {{ item.B1_COD }}
                                            </q-item-label>
                                            <q-item-label caption class="text-grey-6">
                                                {{ item.B1_DESC }}
                                            </q-item-label>
                                        </q-item-section>
                                        <q-item-section side top>
                                            <q-badge color="purple-1" text-color="purple-9" class="q-px-sm">
                                                {{ item.B1_WGRUP }} - {{ item.B1_GRUPO }}
                                            </q-badge>
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-list>
                            <div v-else class="empty-state">
                                <q-icon name="search_off" size="64px" color="grey-4" />
                                <div class="text-h6 text-grey-6 q-mt-md">Sin resultados</div>
                                <div class="text-caption text-grey-5 q-mt-sm">
                                    Ingrese un término de búsqueda para encontrar productos
                                </div>
                            </div>
                        </q-scroll-area>
                    </q-card-section>

                    <q-separator />

                    <q-card-section class="q-pa-sm bg-grey-1">
                        <div class="row items-center justify-between">
                            <div class="text-caption text-grey-7">
                                <q-icon name="info" size="16px" class="q-mr-xs" />
                                Seleccione productos para asignar imagen
                            </div>
                            <q-btn-group unelevated>
                                <q-btn
                                    flat
                                    dense
                                    color="primary"
                                    label="Todos"
                                    @click="agregarTodo"
                                    :disable="items.length === 0"
                                    no-caps
                                    class="action-btn-small"
                                />
                                <q-btn
                                    flat
                                    dense
                                    color="negative"
                                    label="Ninguno"
                                    @click="quitarTodos"
                                    :disable="itemSelected.length === 0"
                                    no-caps
                                    class="action-btn-small"
                                />
                            </q-btn-group>
                        </div>
                    </q-card-section>

                    <q-inner-loading :showing="loading">
                        <q-spinner-hourglass size="50px" color="primary" />
                    </q-inner-loading>
                </q-card>
            </div>

            <div class="col-12 col-md-6">
                <q-card class="seleccionados-card">
                    <q-card-section class="card-header-upload">
                        <div class="row items-center no-wrap">
                            <q-icon name="cloud_upload" size="28px" class="q-mr-sm" />
                            <div class="col">
                                <div class="text-h6 text-weight-bold">Asignar Imagen</div>
                                <div class="text-caption text-white-7 q-mt-xs">
                                    {{ itemSelected.length }} {{ itemSelected.length === 1 ? 'producto seleccionado' : 'productos seleccionados' }}
                                </div>
                            </div>
                        </div>
                    </q-card-section>

                    <q-separator />

                    <q-card-section class="q-pa-md">
                        <q-file
                            outlined
                            dense
                            v-model="imagen"
                            label="Seleccionar imagen"
                            accept="image/*"
                            max-file-size="5242880"
                            @rejected="onRejected"
                            class="upload-input"
                        >
                            <template v-slot:prepend>
                                <q-icon name="attach_file" color="primary" />
                            </template>
                            <template v-slot:append>
                                <q-icon
                                    name="close"
                                    @click.stop.prevent="imagen = null"
                                    class="cursor-pointer"
                                    v-if="imagen"
                                />
                            </template>
                            <template v-slot:hint>
                                Formatos permitidos: JPG, PNG, WEBP (máx. 5MB)
                            </template>
                        </q-file>
                    </q-card-section>

                    <q-separator />

                    <q-card-section class="q-pa-none">
                        <q-scroll-area style="height: 500px">
                            <q-list v-if="itemSelected.length > 0" separator>
                                <template
                                    v-for="item in itemSelected"
                                    :key="item.B1_COD"
                                >
                                    <q-item class="selected-item">
                                        <q-item-section side top>
                                            <q-checkbox
                                                v-model="itemSelected"
                                                :val="item"
                                                color="primary"
                                            />
                                        </q-item-section>
                                        <q-item-section avatar>
                                            <q-avatar size="56px" rounded>
                                                <q-img
                                                    alt="Imagen del producto"
                                                    fit="contain"
                                                    :src="`${productosImagesPath}/${item.B1_COD}.webp`"
                                                    :error-src="noImagePath"
                                                />
                                            </q-avatar>
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label class="text-weight-bold text-grey-9">
                                                {{ item.B1_COD }}
                                            </q-item-label>
                                            <q-item-label caption class="text-grey-6">
                                                {{ item.B1_DESC }}
                                            </q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-list>
                            <div v-else class="empty-state">
                                <q-icon name="photo_library" size="64px" color="grey-4" />
                                <div class="text-h6 text-grey-6 q-mt-md">Sin productos</div>
                                <div class="text-caption text-grey-5 q-mt-sm">
                                    Seleccione productos del catálogo para asignar imagen
                                </div>
                            </div>
                        </q-scroll-area>
                    </q-card-section>

                    <q-separator />

                    <q-card-section class="q-pa-md bg-grey-1">
                        <q-btn
                            unelevated
                            color="positive"
                            icon="save"
                            label="Guardar Imagen"
                            @click="imageStore"
                            :disable="!imagen || itemSelected.length === 0"
                            :loading="uploadLoading"
                            class="full-width action-btn"
                            no-caps
                        >
                            <template v-slot:loading>
                                <q-spinner-hourglass />
                            </template>
                        </q-btn>
                    </q-card-section>

                    <q-inner-loading :showing="uploadLoading">
                        <q-spinner-hourglass size="50px" color="primary" />
                    </q-inner-loading>
                </q-card>
            </div>
        </div>
    </q-page>
</template>

<script setup>
import { ref } from "vue";
import GltnInput from "@/components/form/GltnInput.vue";
import ProductoService from "@/services/ProductoService.js";
import { usePage } from '@inertiajs/vue3';
import { useQuasar } from "quasar";

const $q = useQuasar();
const page = usePage();
const productosImagesPath = page.props.productosImagesPath;
const noImagePath = page.props.noImagePath;
const imagen = ref(null);
const itemSelected = ref([]);
const itemSearch = ref("");
const items = ref([]);
const loading = ref(false);
const uploadLoading = ref(false);

const imageStore = async () => {
    if (!imagen.value || itemSelected.value.length === 0) {
        $q.notify({
            type: "warning",
            message: "Debe seleccionar una imagen y al menos un producto",
            icon: "warning",
        });
        return;
    }

    try {
        uploadLoading.value = true;
        const items = itemSelected.value.map((item) => item.B1_COD);
        const formData = new FormData();
        formData.append("imagen", imagen.value);
        formData.append("productos", JSON.stringify(items));
        await ProductoService.image(formData);
        $q.notify({
            type: "positive",
            message: `Imagen asignada correctamente a ${items.length} ${items.length === 1 ? 'producto' : 'productos'}`,
            icon: "check_circle",
        });
        imagen.value = null;
        itemSelected.value = [];
    } catch (error) {
        console.error("Error uploading image:", error);
        $q.notify({
            type: "negative",
            message: "Error al guardar las imágenes",
            icon: "error",
        });
    } finally {
        uploadLoading.value = false;
    }
};

const productoSearch = async () => {
    try {
        loading.value = true;
        items.value = await ProductoService.search(itemSearch.value);
        if (items.value.length === 0) {
            $q.notify({
                type: "warning",
                message: "No se encontraron productos",
            });
        }
    } catch (error) {
        console.error("Error fetching products:", error);
    } finally {
        loading.value = false;
    }
};

const agregarTodo = () => {
    itemSelected.value = [...itemSelected.value, ...items.value];
};

const quitarTodos = () => {
    itemSelected.value = [];
};

const onRejected = (rejectedEntries) => {
    $q.notify({
        type: "negative",
        message: `${rejectedEntries.length} archivo(s) no cumple(n) con los requisitos`,
        icon: "error",
    });
};
</script>

<style lang="scss" scoped>
@use 'sass:color';

.imagenes-page {
    background: linear-gradient(to bottom, #fafafa 0%, #f5f5f5 100%);
    min-height: 100vh;
}

.page-header {
    background: white;
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin-bottom: 24px;
    animation: fadeInDown 0.5s ease;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    }
}

.chip-active {
    font-size: 14px;
    padding: 8px 16px;
    font-weight: 600;
}

.productos-card,
.seleccionados-card {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }
}

.card-header {
    background: linear-gradient(135deg, #5e35b1 0%, #4527a0 100%);
    color: white;
    padding: 24px;
}

.card-header-upload {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    color: white;
    padding: 24px;
}

.text-white-7 {
    color: rgba(255, 255, 255, 0.85);
}

.product-item {
    transition: all 0.3s ease;
    border-left: 4px solid transparent;
    padding: 16px;

    &:hover {
        background: linear-gradient(to right, #f3e5f5 0%, #fafafa 100%);
        transform: translateX(8px);
        border-left-color: #5e35b1;
    }
}

.selected-item {
    transition: all 0.3s ease;
    border-left: 4px solid transparent;
    padding: 16px;

    &:hover {
        background: linear-gradient(to right, #e3f2fd 0%, #fafafa 100%);
        transform: translateX(8px);
        border-left-color: #1976d2;
    }
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 64px 24px;
    text-align: center;
}

.upload-input {
    :deep(.q-field__control) {
        border-radius: 8px;
    }
}

.action-btn {
    font-weight: 600;
    padding: 12px 24px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }
}

.action-btn-small {
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        transform: scale(1.05);
    }
}

:deep(.q-scrollarea__content) {
    &::-webkit-scrollbar {
        width: 10px;
    }

    &::-webkit-scrollbar-track {
        background: linear-gradient(to bottom, #f5f5f5 0%, #eeeeee 100%);
        border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(to bottom, #bdbdbd 0%, #9e9e9e 100%);
        border-radius: 5px;
        transition: background 0.3s ease;

        &:hover {
            background: linear-gradient(to bottom, #9e9e9e 0%, #757575 100%);
        }
    }
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.productos-card {
    animation: fadeIn 0.4s ease 0.1s backwards;
}

.seleccionados-card {
    animation: fadeIn 0.4s ease 0.2s backwards;
}

@media (max-width: 1023px) {
    .page-header {
        border-radius: 12px;
        padding: 20px;
    }

    .productos-card,
    .seleccionados-card {
        border-radius: 12px;
        margin-bottom: 16px;
    }

    .empty-state {
        padding: 48px 24px;
    }
}

:deep(.q-btn) {
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        transform: translateY(-2px);
    }
}

:deep(.q-badge),
:deep(.q-chip) {
    transition: all 0.2s ease;

    &:hover {
        transform: scale(1.05);
    }
}

:deep(.q-avatar) {
    border: 2px solid rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
}
</style>
